/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Faq_Q6Inputs */

const en_diff_faq_q6 = /** @type {(inputs: Diff_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why does reordering an array produce so many differences?`)
};

const ko_diff_faq_q6 = /** @type {(inputs: Diff_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`배열 순서를 바꾸면 왜 차이가 이렇게 많이 나오나요?`)
};

const ja_diff_faq_q6 = /** @type {(inputs: Diff_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配列の順序を変えるとなぜ差分がこんなに多く出るのですか`)
};

/**
* | output |
* | --- |
* | "Why does reordering an array produce so many differences?" |
*
* @param {Diff_Faq_Q6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_faq_q6 = /** @type {((inputs?: Diff_Faq_Q6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Faq_Q6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_faq_q6(inputs)
	if (locale === "ko") return ko_diff_faq_q6(inputs)
	return ja_diff_faq_q6(inputs)
});